export default __webpack_public_path__ + "static/media/Flaticon.00eacf86.ttf";